module.exports = {"622923100":"刘家峡镇","622923101":"盐锅峡镇","622923102":"太极镇","622923103":"西河镇","622923104":"三塬镇","622923105":"岘塬镇","622923106":"陈井镇","622923107":"川城镇","622923108":"王台镇","622923109":"红泉镇","622923200":"关山乡","622923201":"徐顶乡","622923202":"三条岘乡","622923203":"坪沟乡","622923206":"新寺乡","622923207":"小岭乡","622923208":"杨塔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/622923.json
// module id = 3105
// module chunks = 0